const shadows = {
    SHADOW_100: '0px 0px 1px rgb(54 62 81 / 10%), 0px 1px 3px rgb(54 62 81 / 5%)',
    SHADOW_200: '0 1px 2px 1px rgba(54, 62, 81, 0.1)',
    SHADOW_300: '0 1px 2px 1px rgba(54, 62, 81, 0.1), 0 0 16px 0 rgba(54, 62, 81, 0.05)',
    SHADOW_400: '0 1px 4px 0 rgba(54, 62, 81, 0.2), 0 0 16px 0 rgba(54, 62, 81, 0.1)',
    SHADOW_500: '0 2px 16px 0 rgba(54, 62, 81, 0.2), 0 32px 48px 0 rgba(54, 62, 81, 0.1)',
};
export default shadows;
//# sourceMappingURL=shadows.js.map